import {Deserializable} from "./deserializable.interface";

export class EstadosEncuestasModel implements Deserializable<EstadosEncuestasModel> {
  public idEstadoEncuesta: number;
  public nombreEstadoEncuesta: string;
  public eliminado: boolean;

  constructor(objJson?: any) {
    this.idEstadoEncuesta = objJson.idEstadoEncuesta;
    this.nombreEstadoEncuesta = objJson.nombreEstadoEncuesta;
    this.eliminado = objJson.eliminado;
  }

  deserialize(input: any): EstadosEncuestasModel {
    Object.assign(this, input);
    return this;
  }
}
